"use client";
import { usePathname } from "next/navigation";
import { useState, useCallback } from "react";

export function useMobileMenu() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const pathname = usePathname();

  return { isOpen, toggleMenu, pathname };
}
